import OfficeTypeTable from "./OfficeTypeTable";

const OfficeType = () => {
  return (
    <>
      <OfficeTypeTable />
    </>
  );
};

export default OfficeType;
